import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import hr from "./locales/hr/translation.json";

export const SUPPORTED_LANGUAGES = ["hr", "en"] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const FALLBACK_LANGUAGE: SupportedLanguage = "hr";

// Not i18next's default "i18nextLng": browsers that visited before HR became
// the default still hold an "en" value under that key, and reading a fresh key
// retires those without touching storage directly.
export const LANGUAGE_STORAGE_KEY = "kyc-lng";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            hr: { translation: hr }
        },

        supportedLngs: SUPPORTED_LANGUAGES,

        fallbackLng: FALLBACK_LANGUAGE,

        load: "languageOnly",

        nonExplicitSupportedLngs: true,

        cleanCode: true,

        detection: {
            order: ["localStorage"],
            caches: ["localStorage"],
            lookupLocalStorage: LANGUAGE_STORAGE_KEY
        },

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;